import { REDUX_ACTIONS, GAME_ID } from 'a/wordSlide/data/constants';

const initState = {
  fillColorIndex: 0,
};

const borderReducer = (state = initState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_FILL_COLOR_INDEX:
      return {
        ...state,
        fillColorIndex: payload.colorIndex,
      };

    default:
      return state;
  }
};

export default borderReducer;
